import React from "react";
import {
  StyledContent,
  StyledDefaultIndicator,
  StyledOverlay,
  StyledWrapper,
} from "./Loader.styled";

type LoaderProps = {
  children?: React.ReactNode;
  size?: number;
  loading: boolean;
  className?: string;
  contentClassName?: string;
  fullscreen?: boolean;
};

export const Loader = ({
  children,
  size = 40,
  loading,
  className,
  contentClassName,
  fullscreen,
}: LoaderProps) => {
  return (
    <StyledWrapper
      $fullscreen={fullscreen}
      className={className}
      $hasChildren={!!children}
    >
      {loading && (
        <StyledOverlay $fullscreen={fullscreen} $hasChildren={!!children}>
          <StyledDefaultIndicator $size={size} />
        </StyledOverlay>
      )}
      <StyledContent
        $spinning={loading}
        $fullscreen={fullscreen}
        className={contentClassName}
      >
        {children}
      </StyledContent>
    </StyledWrapper>
  );
};
